function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

export { ownerDocument as o };

//# sourceMappingURL=ownerDocument-d760c4d1.js.map